module.exports = __webpack_public_path__ + "img/thumb_2019-03.4586b17c.jpg";